import { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import { paths, ROOTS } from '@/shared/config/paths';
import { withSuspense } from '../utils';
import type { TypedRouteObject } from '../types';

// 동적 임포트
const Contest = lazy(() => import('@/pages/contest'));
const ContestList = lazy(() => import('@/pages/contest/contest/ContestList'));
const ContestDetail = lazy(() => import('@/pages/contest/contest/ContestDetail'));
const ParticipantsList = lazy(() => import('@pages/contest/participant/ParticipantList'));
const ParticipantsDetail = lazy(() => import('@pages/contest/participant/ParticipantDetail'));
const RecordList = lazy(() => import('@pages/contest/record/RecordList'));
const ContestEmailList = lazy(() => import('@pages/contest/email/ContestEmailList'));

// 대회 관리 라우트
export const contestRoutes: TypedRouteObject = {
	path: ROOTS.CONTEST,
	element: withSuspense(Contest),
	handle: {
		title: '대회 관리',
		subTitle: '락앤런 트레일러닝 대회 관리 현황'
	},
	children: [
		{
			index: true,
			element: <Navigate to="list" replace />
		},
		// 대회
		{
			path: paths.contest.list.path,
			element: withSuspense(ContestList),
			handle: {
				title: '락앤런 대회 관리',
				subTitle: '락앤런 대회 개최 현황 관리'
			}
		},
		{
			path: paths.contest.detail.path,
			element: withSuspense(ContestDetail),
			handle: {
				isGoBack: true,
				title: '락앤런 대회 관리',
				subTitle: '대회 > 대회 관리 > 대회 상세 정보'
			}
		},
		// 참가자
		{
			path: paths.contest.participant.list.path,
			element: withSuspense(ParticipantsList),
			handle: {
				title: '락앤런 대회 참가자 관리',
				subTitle: '락앤런 대회 참가자 현황 및 관리'
			}
		},
		{
			path: paths.contest.participant.detail.path,
			element: withSuspense(ParticipantsDetail),
			handle: {
				isGoBack: true,
				title: '락앤런 대회 참가자 관리',
				subTitle: '대회 > 참가자 관리 > 참가자 상세 정보'
			}
		},
		// 기록 관리
		{
			path: paths.contest.record.list.path,
			element: withSuspense(RecordList),
			handle: {
				title: '락앤런 대회 기록 관리',
				subTitle: '락앤런 대회 참가자 현황 및 관리'
			}
		},
		// 이메일 발송
		{
			path: paths.contest.email.list.path,
			element: withSuspense(ContestEmailList),
			handle: {
				title: '락앤런 이메일 발송 관리',
				subTitle: '락앤런 대회 참가자 이메일 발송 현황 및 관리'
			}
		},
	]
};
